export default __webpack_public_path__ + "static/098-739a5a3c2969a75f0b671133c1629f43.jpg";